
import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/common/services/api.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { AuthenticationService } from '../../auth/authentication.service';
import { Router, ActivatedRoute } from '@angular/router';
import { OfferService } from '../../offer/offer.service';

@Component({
    selector: 'portal-home',
    templateUrl: './portal-home.component.html'
})
export class PortalHomeComponent implements OnInit {

    public products: any[] = [];
    public right_side_bar: boolean;
    constructor(public translate: TranslateService,
                public apiService: ApiService,
                private toastrService: ToastrService,
                private authenticationService: AuthenticationService,
                private offerService: OfferService,
                private router: Router,
                private route: ActivatedRoute,    ) { }

    ngOnInit() {
        this.getProducts();
    }

    getProducts() {
        this.apiService.post("API/WebUserAPI/Products", {}).subscribe((result: any) => {
            this.products = this.productSort(result.rows);
        });
    }

    productSort(products) {
        var tempProducts = [];
        for (var key in products) {
            if (products[key].ProductCode == "9885") {
                products[key].ImageUrl = products[key].DepartmentCode + "_c.png";
                tempProducts.push(products[key]);
                break;
            }
        }

        for (var key in products) {
            if (products[key].ProductCode == "9886") {
                products[key].ImageUrl = products[key].DepartmentCode + "_y.png";
                tempProducts.push(products[key]);
                break;
            }
        }

        for (var key in products) {
            if (products[key].ProductCode == "9918") {
                products[key].ImageUrl = products[key].DepartmentCode + "_c.png";
                tempProducts.push(products[key]);
                break;
            }
        }

        for (var key in products) {
            if (products[key].ProductCode != "9885" &&
                products[key].ProductCode != "9886" &&
                products[key].ProductCode != "9918") {
                products[key].ImageUrl = products[key].DepartmentCode + "_c.png";
                tempProducts.push(products[key]);
            }
        }

        return tempProducts;
    }

    newOffer(product) {
        this.offerService.offerHeaderKey = "";
        this.offerService.versionNo = "";
        if (this.authenticationService.User == null) {
            this.toastrService.error(this.translate.instant("Please login to create quote."));
        }
        else {
            var model = {
                ClientKey: "",
            };

            this.apiService.post("Api/WebUserAPI/ClientTemplates/", model).subscribe((res) => {
                this.offerService.clientNewOffer = res["CLIENT_NEWOFFER"];
                this.offerService.departmentCode = product.DepartmentCode;
                this.offerService.productCode = product.ProductCode;
                this.offerService.processCode = product.ProcessCode;
                this.offerService.clientCode = 0;
                this.router.navigate(["../Offer/New"], { relativeTo: this.route });
            });
        }
    }
}
